import { createContext } from "react";

export const ContentControllerContext = createContext();
